import {
  HearNaviQuestionnaireAnswerRequest,
  HearNaviQuestionnaireDetailRequest,
  HearNaviUnlinkedQuestionnaireRequest,
} from '../../../component/organisms/HearNaviDialog';
import { OpenScheduleManagementRequest } from '../../../component/organisms/ScheduleManagementDialog';
import * as SimulatorDialog from '../../../component/organisms/SimulatorDialog';
import { ENV_KEYS, getEnvValueBoolean, getEnvValue } from '../../../utils/Env';

export enum GINIE_PAGE_CONSTANTS {
  REGISTER = 'SG2NWR',
  CUSTOMER_DETAILS = 'cust',
  POWER_STATUS = 'PRS',
  YM_CONTRACT = 'EXC',
}

export const BSW_PAGE_CONSTANTS = {
  MAIN: 'BSW',
};

export enum GINIE_BROWSER_TABS {
  GINIE = 'GINIE',
  GINIE_OPEN_OVERWRITING_OTHER_TAB = 'GINIE?noCloseOk',
  GINIE_OPEN_IF_NO_OTHER_TAB = 'GINIE?CloseSel',
  BSW = 'BSW',
  RYOKIN_SIMULATOR = 'SB_RYOKIN_SIMULATOR',
  SHOP_RESERVE = 'SCHEDULING_MANAGEMENT',
  AREA_SEARCH = 'AREA_SEARCH',
  HEARNAVI = 'HEARNAVI',
  SB_CREWNABI = 'SB_CREWNABI',
  SOFTBANK_OFFICIAL = 'SOFTBANK_OFFICIAL',
}

export interface ComeShopReserveRequest {
  shopCd: string;
  staffCd: string;
  routeKbn: string;
  ginieAcceptNo: string;
  lastNm: string;
  firstNm: string;
  msnNbr: string;
  mail: string;
  messageType: string;
  customerNo: string;
  actionId: number;
  negotiationId: number;
  method: string;
}

export const callGinieRegister = (newRegistCheckNo: string) => {
  openGinieWindowWithOverwrite(createGinieUrl(newRegistCheckNo, GINIE_PAGE_CONSTANTS.REGISTER));
};

export const callGinieCustomerDetails = (newRegistCheckNo: string, newEcmMsn: string) => {
  openGinieWindowWithOverwrite(createGinieUrl(newRegistCheckNo, GINIE_PAGE_CONSTANTS.CUSTOMER_DETAILS, newEcmMsn));
};

export const callGinieYmContractEdit = (newRegistCheckNo: string, newEcmMsn: string) => {
  openGinieWindowWithOverwrite(createGinieUrl(newRegistCheckNo, GINIE_PAGE_CONSTANTS.YM_CONTRACT, newEcmMsn));
};

export const callGiniePowerStatus = (newRegistCheckNo: string) => {
  openGinieWindowWithOverwrite(createGinieUrl(newRegistCheckNo, GINIE_PAGE_CONSTANTS.POWER_STATUS));
};

export const goToGinieTab = () => {
  openGinieWindowWithOverwrite('');
};

export const callBsw = (crewCode: string, agencyCode: string, newRegistCheckNo: string, verificationId?: string, categoryType?: string) => {
  const queryParams = verificationId
    ? {
        af: 'pcm_prospect',
        gstaffcd: crewCode,
        sbmac: agencyCode,
        vcCustomerNoProspect: newRegistCheckNo,
        verificationId: verificationId,
        categoryType: categoryType,
      }
    : {
        af: 'pcm_prospect',
        gstaffcd: crewCode,
        sbmac: agencyCode,
        vcCustomerNoProspect: newRegistCheckNo,
      };
  const url = `BSWENT/auth?${generateQueryParametersString(queryParams)}`;
  openBswWindow(url);
};

const SIMULATOR_URL = getEnvValue(ENV_KEYS.REACT_APP_SIMULATOR_URL);
const SIMULATOR_REFERRER = getEnvValue(ENV_KEYS.REACT_APP_SIMULATOR_REFERRER);
export const callRyokinSimulator = (request: SimulatorDialog.SbRyokinSimulatorRequest) => {
  const queryParams = { ...request, Referrer: SIMULATOR_REFERRER };
  const url = `${SIMULATOR_URL}?${generateQueryParametersString(queryParams)}`;
  openRyokinSimulatorWindow(url);
};

export const callGinieCustomerReference = (request: SimulatorDialog.GinieRequest) => {
  const url = `ICVENT/icv?${generateQueryParametersString(request)}`;
  openGinieWindowWithOverwrite(url);
};

export const comeShopReserve = (request: ComeShopReserveRequest) => {
  const url = `obs/login/doIpadSso?${generateQueryParametersString(request)}`;
  openShopReserveWindow(url);
};

export const callAreaCheck = (agencyCode: string, staffId: string, productId: string) => {
  const url = 
    `ARCHK/areaCheck/?AgencyCode=${agencyCode}&StaffId=${staffId}&ProductId=${productId}`
  openAreaCheckWindow(url);
};

export const callDiversionNumberWestJapan = () => {
  const url = `https://flets-w.com/collabo/`;
  openAreaCheckDiversionNumberWindow(url);
};

export const callDiversionNumberEastJapan = () => {
  const url = `https://flets.com/app4/input/index/`;
  openAreaCheckDiversionNumberWindow(url);
};

export const callCrewNavi = (url: string) => {
  openCrewNaviWindow(url);
};

export const callHearNaviQuestionnaire = (request: HearNaviQuestionnaireDetailRequest, hearingId: string) => {
  const url = `questionnaire/${hearingId}/?${generateQueryParametersString(request)}`;
  openHearNaviWindow(url);
};

export const callHearNaviRegisterQuestionnaire = (request: HearNaviQuestionnaireAnswerRequest) => {
  const url = `registerQuestionnaire/?${generateQueryParametersString(request)}`;
  openHearNaviWindow(url);
};

export const callHearNaviLinkedQuestionnaireList = (request: HearNaviUnlinkedQuestionnaireRequest) => {
  const url = `LinkedQuestionnaireList/?${generateQueryParametersString(request)}`;
  openHearNaviWindow(url);
};

export const callScheduleManagement = (request: OpenScheduleManagementRequest) => {
  const url = `obs/login/doIpadSso?${generateQueryParametersString(request)}`;
  openScheduleManagementWindow(url);
};

export const callSoftbankOfficial = (url: string) => {
  openSoftbankOfficialWindow(url);
};

// 未使用のためコメントアウト
// const openGinieWindow = selectTabPageFacade(GINIE_BROWSER_TABS.GINIE);
const openGinieWindowWithOverwrite = selectTabPageFacade(GINIE_BROWSER_TABS.GINIE_OPEN_OVERWRITING_OTHER_TAB);
// 未使用のためコメントアウト
// const openGinieWindowIfNoOtherTab = selectTabPageFacade(GINIE_BROWSER_TABS.GINIE_OPEN_IF_NO_OTHER_TAB);
const openBswWindow = selectTabPageFacade(GINIE_BROWSER_TABS.BSW);
const openRyokinSimulatorWindow = selectTabPageFacade(GINIE_BROWSER_TABS.RYOKIN_SIMULATOR);
const openShopReserveWindow = selectTabPageFacade(GINIE_BROWSER_TABS.SHOP_RESERVE);
const openAreaCheckWindow = selectTabPageFacadeAreaCheck(GINIE_BROWSER_TABS.AREA_SEARCH, false);
const openAreaCheckDiversionNumberWindow = selectTabPageFacadeAreaCheck(GINIE_BROWSER_TABS.AREA_SEARCH, true);
const openHearNaviWindow = selectTabPageFacade(GINIE_BROWSER_TABS.HEARNAVI);
const openScheduleManagementWindow = selectTabPageFacade(GINIE_BROWSER_TABS.SHOP_RESERVE);
const openCrewNaviWindow = selectTabPageCrewNavi(GINIE_BROWSER_TABS.SB_CREWNABI);
const openSoftbankOfficialWindow = selectTabPageSoftbankOfficial(GINIE_BROWSER_TABS.SOFTBANK_OFFICIAL);

const generateQueryParametersString = (request: Object) =>
  Object.entries(request)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

const createGinieUrl = (newRegistCheckNo: string, flwName: string, newEcmMsn?: string) => {
  return `ICVENT/icv?_ControlID=XFC303Control&newRegistCheckNo=${newRegistCheckNo}${
    newEcmMsn ? `&newEcmMsn=${newEcmMsn}` : ''
  }&flwName=${flwName}`;
};

function selectTabPageFacade(selectTab: GINIE_BROWSER_TABS) {
  return (relationUrl: string) => {
    if (window.external.SelectTabPage) {
      window.external.SelectTabPage(selectTab, relationUrl);
    } else if (getEnvValueBoolean(ENV_KEYS.REACT_APP_IS_CONFIRM_EXTERNAL_SYSTEM_BY_TAB)) {
      // arg2の値にURLパスが含まれる場合があるためエンコードする
      window.open(`http://localhost:53555/selectTabPageMock/?arg1=${selectTab}&arg2=${encodeURIComponent(relationUrl)}`, '_blank');
    }
  };
}

// TODO エリア検索の外部結合以降、selectTabPageFacadeと纏める
function selectTabPageFacadeAreaCheck(selectTab: string, useFullURL: boolean) {
  return (relationUrl: string) => {
    if (useFullURL === true) {
      window.open(relationUrl, '_blank');
    } else {
      if (window.external.SelectTabPage) {
        window.external.SelectTabPage(selectTab, relationUrl);
      } else if (getEnvValueBoolean(ENV_KEYS.REACT_APP_IS_CONFIRM_EXTERNAL_SYSTEM_BY_TAB)) {
        window.open(`http://localhost:53555/${relationUrl}&selectTab=${selectTab}`, '_blank');
      }
    }
  };
}

function selectTabPageCrewNavi(selectTab: GINIE_BROWSER_TABS) {
  return (relationUrl: string) => {
    if (!relationUrl) return;

    const canUseExternalSelectTabPage = 'external' in window && !!window.external && typeof window.external.SelectTabPage === 'function';

    // GINIEブラウザの場合
    if (canUseExternalSelectTabPage) {
      // canUseExternalSelectTabPage がtrueなので、window.external.SelectTabPageは必ず存在します
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      window.external.SelectTabPage!(selectTab, relationUrl);
      return;
    }

    // GINIEブラウザ以外の場合
    openViaAncchor(`${process.env.REACT_APP_CREW_NAVI_FQDN}/${relationUrl}`);
  };
}

function selectTabPageSoftbankOfficial(selectTab: GINIE_BROWSER_TABS) {
  return (relationUrl: string) => {
    if (!relationUrl) return;

    const canUseExternalSelectTabPage = 'external' in window && !!window.external && typeof window.external.SelectTabPage === 'function';

    // GINIEブラウザの場合
    if (canUseExternalSelectTabPage) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      window.external.SelectTabPage!(selectTab, relationUrl);
      return;
    }

    // GINIEブラウザ以外の場合
    openViaAncchor(relationUrl);
  };
}

// window.openはIOS上のブラウザ(ChromeやSafari)での動作が安定しないため、アンカーリンクの方式で別タブを開く
const openViaAncchor = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank'; // 新規タブ
  a.rel = 'noopener noreferrer'; // セキュリティ パフォーマンス
  document.body.appendChild(a);
  a.click();
  a.remove();
};
